<template>
    <a v-if="data" @click="navigate(data.id)" class="cursor-pointer">
        <div class="thumb-card">
            <img v-if="data.product_images.length" :src="data.product_images[0].image" class="thumb-card-image" :alt="data.translate.length ? data.translate[0].name : ''">
            <div class="thumb-card-overlay">
                <!-- <div class="thumb-card-content"> -->
                    <h2 class="thumb-card-title">
                        {{ data.translate.length ? data.translate[0].name : '' }}
                    </h2>
                <!-- </div> -->
            </div>
        </div>
    </a>
</template>


<script>
// import { ref } from 'vue';

export default {
    name: 'ThumbCardC',
    props: ['data'],
    emits: ['navigate'],
    setup(props, { emit }) {
        const navigate = (sectionId) => {
            emit('navigate', sectionId);
        };

        return {
            navigate,
        };
    },
}
</script>


<style lang="scss">
.thumb-card {
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    // width: 16.6%;
    // max-width: 16.6%;
    width: 100%;
    height: 120px;
    position: relative;
    // box-shadow:
    //     0 20px 50px rgba(0, 0, 0, 0.3),
    //     0 0 0 1px rgba(255, 255, 255, 0.1);
}

.thumb-card-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    /* transition: transform 8s ease-out; */
    transition: all 5s cubic-bezier(0.23, 1, 0.32, 1);
    border-radius: 10px;
}

.thumb-card-overlay {
    border-radius: 10px;
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: var(--background-gradient);
}

.thumb-card-title {
    // font-size: clamp(2.5rem, 6vw, 5rem);
    font-size: 1rem;
    color: #ffffff;
    font-weight: 800;
    // line-height: 1.1;
    // margin-bottom: 1.5rem;
    text-shadow: 0 5px 20px rgba(0, 0, 0, 0.5);
}
</style>